import { TransactionStatus } from '@delmonicos/shared-sdk/libs/cpms/src/libs/transaction-service-lib/src/wrapper/enums/transaction-status.enum';

interface EmspBoTransactionStatusStyle {
  color: string;
}

const EMSP_BO_TRANSACTION_STATUS_MAP: Record<
  TransactionStatus,
  EmspBoTransactionStatusStyle
> = {
  // TERMINAL ERRORS ///////////////////////////////////////////////////////////
  [TransactionStatus.SESSION_INVALID]: {
    color: 'bg-surface-error',
  },
  [TransactionStatus.START_CHARGE_CPO_REFUSED]: {
    color: 'bg-surface-error',
  },
  [TransactionStatus.START_CHARGE_CP_TIMEOUT]: {
    color: 'bg-surface-error',
  },
  [TransactionStatus.START_CHARGE_CP_REFUSED]: {
    color: 'bg-surface-error',
  },
  [TransactionStatus.SESSION_START_TIMEOUT]: {
    color: 'bg-surface-error',
  },
  [TransactionStatus.STOP_CHARGE_CPO_REFUSED]: {
    color: 'bg-surface-error',
  },
  [TransactionStatus.STOP_CHARGE_CP_TIMEOUT]: {
    color: 'bg-surface-error',
  },
  [TransactionStatus.STOP_CHARGE_CP_REFUSED]: {
    color: 'bg-surface-error',
  },
  [TransactionStatus.SESSION_STOP_TIMEOUT]: {
    color: 'bg-surface-error',
  },
  // PENDING / TRANSITIONAL ////////////////////////////////////////////////////
  [TransactionStatus.START_CHARGE_CPO_ACCEPTED]: {
    color: 'bg-surface-informations',
  },
  [TransactionStatus.START_CHARGE_CP_ACCEPTED]: {
    color: 'bg-surface-informations',
  },
  [TransactionStatus.SESSION_PENDING]: {
    color: 'bg-surface-informations',
  },
  [TransactionStatus.STOP_CHARGE_CPO_ACCEPTED]: {
    color: 'bg-surface-informations',
  },
  [TransactionStatus.STOP_CHARGE_CP_ACCEPTED]: {
    color: 'bg-surface-informations',
  },
  // ACTIVE ////////////////////////////////////////////////////////////////////
  [TransactionStatus.SESSION_STARTED]: {
    color: 'bg-surface-brand-secondary',
  },
  // SUCCESS ///////////////////////////////////////////////////////////////////
  [TransactionStatus.SESSION_ENDED]: {
    color: 'bg-surface-success',
  },
  [TransactionStatus.CDR_EDITED]: {
    color: 'bg-surface-success',
  },
};

export const mapEmspBoTransactionStatusToStyle = (
  status: TransactionStatus,
): EmspBoTransactionStatusStyle => {
  return (
    EMSP_BO_TRANSACTION_STATUS_MAP[status] ?? {
      color: 'bg-surface-informations',
    }
  );
};
